import React, { useLayoutEffect, useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * ScrollToTop component that scrolls the window to the top on route changes.
 * This version has added error handling to prevent crashes in production builds.
 */
export const ScrollToTop: React.FC = () => {
  // Track if component has mounted and any errors
  const [error, setError] = useState<Error | null>(null)

  try {
    // Get current location from router
    const location = useLocation()
    const { pathname } = location || {}

    // Effect to scroll to top when pathname changes
    useLayoutEffect(() => {
      try {
        if (typeof window !== 'undefined') {
          window.scrollTo(0, 0)
        }
      } catch (scrollError) {
        console.error('ScrollToTop: Error scrolling to top:', scrollError)
        // Don't set error state here as it's not critical
      }
    }, [pathname])

    // Report any errors but still render null
    if (error) {
      console.error('ScrollToTop: Component error:', error)
    }

    return null
  } catch (locationError) {
    // If useLocation fails, log error but don't crash
    console.error('ScrollToTop: Error getting location:', locationError)

    // Still try to scroll to top once
    useEffect(() => {
      try {
        if (typeof window !== 'undefined') {
          window.scrollTo(0, 0)
        }
      } catch (fallbackScrollError) {
        console.error(
          'ScrollToTop: Fallback scroll error:',
          fallbackScrollError
        )
      }
    }, [])

    return null
  }
}
